module.exports = __webpack_public_path__ + "img/chicken_meets_worm_preview.e029c044.png";